export default __webpack_public_path__ + "c91fdb4.mp3";